import Cookies from 'js-cookie';
import { clearErrors, setAlert, setSuccess } from './alertActions';

// API
import { login, logout } from '../../api';

// Constants

import {
  IS_LOADING,
  IS_NOT_LOADING,
  AUTHENTICATED,
  NOT_AUTHENTICATED,
} from '../reducers/authReducer';

const COOKIE_NAME = process.env.REACT_APP_COOKIE_NAME;

// Actions
export const startLoading = () => ({
  type: IS_LOADING
});

export const stopLoading = () => ({
  type: IS_NOT_LOADING
});

export const authenticated = () => ({
  type: AUTHENTICATED,
});

export const notAuthenticated = () => ({
  type: NOT_AUTHENTICATED
});

/* ----- AUTHENTICATE ----- */

export const authenticateUser = (dispatch, email = null, password = null) => {
  dispatch(startLoading());

  login({ email, password }).then(() => {
    dispatch(clearErrors());
    dispatch(authenticated());
  }).catch(error => {
    setAlert(dispatch, error);
    dispatch(notAuthenticated());
  });
};

export const checkAuthentication = (dispatch, isAuthenticated) => {
  dispatch(startLoading());

  // If we falsely have the user logged in, log them out and clear all cookies.
  if ((Cookies.get(COOKIE_NAME) === undefined && isAuthenticated)) {
    logoutUser(dispatch);
  }

  else if (Cookies.get(COOKIE_NAME) !== undefined && !isAuthenticated) {
    // If both cookies are there, fully authenticate
    dispatch(authenticated());
  }

  else {
    dispatch(stopLoading());
  }
};

export const logoutUser = (dispatch) => {
  // Revoke tokens and unauthenticate in redux state
  if (Cookies.get(COOKIE_NAME) !== undefined) {
    logout().then(() => {
      setSuccess('Successfully logged out.');
      clearCookies(dispatch);
    }).catch(() => {
      clearCookies(dispatch);
    });
  }
  else clearCookies(dispatch);
};

export const clearCookies = (dispatch) => {
  Cookies.remove(COOKIE_NAME, { path: '/', domain: process.env.REACT_APP_COOKIE_DOMAIN });
  dispatch(notAuthenticated());
};
